import { gql } from "@apollo/client";
import {
  ADDRESS_FRAGMENT,
  CCMS_SUSPENSION_FRAGMENT,
  PERSON_DETAILS_FRAGMENT,
  PHONE_NUMBER_FRAGMENT
} from "@/fragments";

export const PERSON_SIDE_SHEET_QUERY = gql`
  query PersonSideSheet($pgaId: ID!) {
    person(pgaId: $pgaId) {
      ...PersonDetailsFragment
      age
      membershipSince
      totalJobApplications
      totalActiveJobApplications
      groupAssignments {
        id
        startedAt
        expiresAt
        group {
          id
          name
        }
      }
    }
  }
  ${PERSON_DETAILS_FRAGMENT}
`;

export const PERSON_SIDE_SHEET_EDUCATION_QUERY = gql`
  query PersonSideSheetEducation($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      university {
        id
        name
      }
    }
  }
`;

export const PERSON_SIDE_SHEET_MEMBERSHIP_QUERY = gql`
  query PersonSideSheetMembership($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      latestProgram {
        id
        status
        programType {
          id
          name
        }
        band {
          id
          startedOn
          expiresOn
          classification {
            id
            name
            description
            programType {
              id
              name
            }
          }
          programType {
            id
            name
          }
        }
      }
      ccmsSuspensions {
        ...CcmsSuspensionFragment
      }
    }
  }
  ${CCMS_SUSPENSION_FRAGMENT}
`;

export const PERSON_SIDE_SHEET_CONTACT_QUERY = gql`
  query PersonSideSheetContact($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      email
      phoneNumbers {
        ...PhoneNumberFragment
      }
      addresses {
        ...AddressFragment
      }
      age
      dob {
        day
        month
        year
      }
      gender
    }
  }
  ${PHONE_NUMBER_FRAGMENT}
  ${ADDRESS_FRAGMENT}
`;
